module.exports = __webpack_public_path__ + "static/img/zuo.dc08768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/gongchengshi/zuo.png
// module id = u+Qq
// module chunks = 6